import { Box, Button, SvgIcon } from "@mui/material";
import { default as React } from "react";
import { Calendar as CalendarIcon } from "react-feather";

interface CalendarButtonProps {
    handleClick: (event: React.MouseEvent<HTMLElement>) => void;

    disableRipple?: boolean;
    className?: string;
    disabled?: boolean;
}

export const CalendarButton = React.forwardRef<any, React.PropsWithChildren<CalendarButtonProps>>(
    ({ handleClick, disableRipple, className, children, disabled = false }, ref) => {
        return (
            <Button
                disableRipple={disableRipple}
                disableFocusRipple
                ref={ref}
                onClick={handleClick}
                className={className}
                disabled={disabled}
            >
                <Box display="flex" alignItems="center">
                    <Box mt={0.5}>
                        <SvgIcon fontSize="small" color="primary">
                            <CalendarIcon />
                        </SvgIcon>
                    </Box>
                    <Box mt={-0.2}>{children}</Box>
                </Box>
            </Button>
        );
    }
);
